import React, { useEffect, useState } from "react";
import * as animationData from "./loadingAnimation.json";
import Lottie from "react-lottie";
import css from "../../style/visionStyle.module.css";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const loadingMessages = [
  "Scanning your photos, this may take a minute while we detect all items.",
  "Next step: review the list and add or remove any missed items.",
  "Our AI agent sizes the truck and crew based on the items it finds.",
  "Your estimate is image-based; final billing follows actual on-site work time.",
  "Finish early, you pay less; runs long, it may be slightly more.",
  "Double-check fragile items are well packed.",
  "You can edit item quantities later; accurate counts keep your quote tight.",
  "We'll show you the cost breakdown before you confirm anything.",
  "Please check if any items are prohibited or restricted.",
  "Thanks for waiting; your quote is loading and almost ready.",
];

const VisionLoading = ({ showPaymentMessage = true }) => {
  const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const fadeOutTimeout = setTimeout(() => {
      setFade(true); // Start fade out
    }, 4500);

    const messageChangeTimeout = setTimeout(() => {
      setLoadingMessageIndex((prev) =>
        prev === loadingMessages.length - 1 ? 0 : prev + 1,
      );
      setFade(false); // Fade back in
    }, 5000);

    return () => {
      clearTimeout(fadeOutTimeout);
      clearTimeout(messageChangeTimeout);
    };
  }, [loadingMessageIndex]);

  return (
    <div className={css?.visionLoadingMD}>
      <div className={css?.loadingDiv}>
        <img
          src="/images/visionLoadingIcon.png"
          alt="moovez"
          className={css?.loadingFrog}
        />
        <Lottie options={defaultOptions} height={60} width={200} />
        <div
          className={`${css?.paymentProcessingMessage} ${css.fadeText} ${
            fade ? css.fadeOut : ""
          }`}
          style={{ display: showPaymentMessage ? "block" : "none" }}
        >
          {loadingMessages[loadingMessageIndex]}
        </div>
      </div>
    </div>
  );
};

export default VisionLoading;
